<div class="wizard-page" *ngIf="process">
  <div class="bp-page-header">
    <button pButton type="button" class="easymarine link back-button"
      icon="pi pi-list" label="Voltar para processos" (click)="confirmarSaida()"></button>
    <div class="title-area">
      <h2><i class="pi pi-list-check"></i> {{ process.description }}</h2>
      <p class="subtitle">
        Processo de faturamento — acompanhe o passo a passo abaixo.
      </p>
    </div>
  </div>

  <div class="wizard-steps">
    <p-steps [model]="steps" [activeIndex]="activeStepIndex"
      [readonly]="false"
      (activeIndexChange)="goToStep($event)"></p-steps>
  </div>

  <div class="wizard-content">
    <app-wizard-step-services *ngIf="activeStepIndex === 0"
      [process]="process"
      (next)="proximo()"></app-wizard-step-services>

    <app-wizard-step-existing-orders *ngIf="activeStepIndex === 1"
      [process]="process"
      (next)="proximo()"
      (back)="anterior()"></app-wizard-step-existing-orders>

    <app-wizard-step-invoice-preview *ngIf="activeStepIndex === 2"
      [process]="process"
      (next)="proximo()"
      (back)="anterior()"></app-wizard-step-invoice-preview>

    <app-wizard-step-invoice-data *ngIf="activeStepIndex === 3"
      [process]="process"
      (next)="proximo()"
      (back)="anterior()"></app-wizard-step-invoice-data>

    <app-wizard-step-confirmation *ngIf="activeStepIndex === 4"
      [process]="process"
      (next)="proximo()"
      (back)="anterior()"></app-wizard-step-confirmation>

    <div class="placeholder-step" *ngIf="activeStepIndex === 5">
      <i class="pi pi-clock"></i>
      <h3>Execução</h3>
      <p>Etapa em desenvolvimento.</p>
    </div>
  </div>

  <div class="wizard-nav" *ngIf="activeStepIndex >= 5">
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-arrow-left" label="Anterior"
      (click)="anterior()"></button>
  </div>
</div>
